const LANGUAGE_ALIASES = {
  spanish: 'es-MX',
  english: 'en-US',
  chinese: 'zh-CN',
};

const resolveLanguageKey = (lang) => LANGUAGE_ALIASES[lang] || lang;

export default resolveLanguageKey;
